import { DEFAULT_THEME_COLOR } from '@/types';

/**
 * Simple theme utility for restaurant theme color
 */

/**
 * Get restaurant theme color with fallback to default
 */
export const getThemeColor = (themeColor?: string): string => {
  return themeColor || DEFAULT_THEME_COLOR;
};

/**
 * Apply theme color to document as CSS custom property
 */
export const applyThemeColor = (themeColor: string): void => {
  const root = document.documentElement;
  root.style.setProperty('--theme-color', themeColor);
};
